import store from '../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../helpers/PGSHelper.js';
import _ from 'lodash';
export default class Tarifa {
  static $pgsHelper      = new PGSHelper(); //online || local
  static async getMixTarifasCombo(departamentos) {
    let tarifaCombo = [];
    const snapshot = await store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas/" + departamentos + "/Coleccion")
    if (snapshot.exists()) {
      let arrayTarifas = Object.entries(snapshot.val());
      arrayTarifas.forEach((element) => {
        tarifaCombo.push({ Id: element[0], ...element[1] });
      });
    }
    return tarifaCombo;
  }
  static async getAllTarifarios() {
    let tarifarios = [];
    //const snapshot = await store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas/" + departamentos + "/Coleccion")
    const snapshot = await store.getters.getFirebaseApp.database.queryBuilder("RVA/Tarifas")

    if (snapshot.exists()) {
      let arrayTarifas = Object.entries(snapshot.val());
      arrayTarifas.forEach((element) => {
        if(element[1].Coleccion){
          let tarifariosArray = Object.entries(element[1].Coleccion)
          tarifariosArray.forEach((tarifario)=>{
            tarifarios.push({ Id: tarifario[0], ...tarifario[1] });
          })
        }
        
      });
    }
    return tarifarios;
  }
  static async getMixTarifasComboByAcceso(departamentos, idMayorista) {
    let tarifaCombo = [];
    const database = store.getters.getFirebaseApp.database
    const snapshot = await database.queryBuilder(
      "RVA/Tarifas/" + departamentos + "/Coleccion"
      /*[
        database.orderByChild('Accesos/' + idMayorista),
        database.equalTo(true)
      ]*/
    )
    if (snapshot.exists()) {

      let arrayTarifas = Object.entries(snapshot.val());
      arrayTarifas.forEach((element) => {
        if(element[1].Accesos[idMayorista]){
          tarifaCombo.push({ Id: element[0], ...element[1] });
        }
      });
    }
    return tarifaCombo;
  }
  static async getMixTarifasByTarifario(tarifa, departamentos,temporada = null) {
    /*const firestore = store.getters.getFirebaseApp.firestore;
    let filter = [
      firestore.where('Tarifario', '==', tarifa),
      firestore.where('Departamento', '==', departamentos),
      firestore.where("Tenant", "==", store.getters.getFirebaseApp.tenant)
    ]
    if(temporada){
      
      filter.push(firestore.where("Temporada", "==", temporada))
    }
    const data = await firestore.queryBuilder(
      "RVA_Tarifas",
      filter
    );
    let tar = data.docs.map(doc => { return { id: doc.ref.id, ...doc.data() } });
    */
    let tarifasList = store.getters["dataLists/getRVATarifas"];
    let tarDepto = _.filter(tarifasList, function (o) {
      if(departamentos){
        return o.Departamento== departamentos
      }else{
        return o;
      }
      
    });
    let tarifasMatched = _.filter(tarDepto, function (o) {
      if(temporada){
        return o.Tarifario == tarifa && o.Temporada == temporada
      }else{
        return o.Tarifario == tarifa;
      }
      
    });

    let tar = tarifasMatched;

    tar.forEach((tarifaData) => {

      let arrayPrecios = [];
      let arrayDays = Object.entries(tarifaData.Precios);
      arrayDays.forEach((mod) => {
        let modDias = mod[0].split("-");
        let textDias = "";
        modDias.forEach((element) => {
          textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
        });
        let arrayModalidades = Object.entries(mod[1]);
        arrayModalidades.forEach((modalidad) => {
          let dataModalidades = { id: modalidad[0], textDias: textDias, dias: modDias, horarios: [] };
          let arrayHorarios = Object.entries(modalidad[1]);
          arrayHorarios.forEach((horario) => {
            let dataHorarios = {
              id: horario[0],
              ...horario[1]
            }
            dataModalidades.horarios.push(dataHorarios);
          });
          arrayPrecios.push(dataModalidades);
        });


        tarifaData.arrayPrecios = arrayPrecios;

      })
    })

    return tar;
  }
  static async getMixTarifasByTarifarioParse(tarifa, temporada, departamento, arrayhorarios, arraytemporadas, arraytiposJuego, dayWeek) {

    /*const firestore = store.getters.getFirebaseApp.firestore;
    let filters = [
      firestore.where('Tarifario', '==', tarifa),
      firestore.where('Departamento', '==', departamento),
      firestore.where("Tenant", "==", store.getters.getFirebaseApp.tenant)
    ]
    if (temporada) {
      filters.push( firestore.where("Temporada", "==", temporada));
    }
    const data = await firestore.queryBuilder(
      "RVA_Tarifas",
      filters
    );
    let tar = data.docs.map(doc => { return { id: doc.ref.id, ...doc.data() } });*/

    let tarifasList = store.getters["dataLists/getRVATarifas"];
    let tarifasMatched = _.filter(tarifasList, function (o) {
      if (temporada) {
        return o.Tarifario == tarifa && o.Temporada == temporada
      }
      return o.Tarifario == tarifa;
    });

    let tar = tarifasMatched;


    tar.forEach((tarifaData) => {
      tarifaData.data = this.$pgsHelper.getById(arraytemporadas, 'id', tarifaData.Temporada);
      let arrayPrecios = [];
      let arrayDays = Object.entries(tarifaData.Precios);
      arrayDays.forEach((mod) => {
        let modDias = mod[0].split("-");
        let textDias = "";
        modDias.forEach((element) => {
          textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
        });
        let arrayModalidades = Object.entries(mod[1]);

        arrayModalidades.forEach((modalidad) => {
          let dataModalidades = { id: modalidad[0], dias: modDias, horarios: [] };
          dataModalidades.data = this.$pgsHelper.getById(arraytiposJuego, 'id', modalidad[0]);
          let arrayHorarios = Object.entries(modalidad[1]);
          arrayHorarios.forEach((horario) => {
            let dataHorarios = {
              id: horario[0],
              internalId: tarifaData.id + '-' + dataModalidades.id + '-' + horario[0],
              data: this.$pgsHelper.getById(arrayhorarios, 'id', horario[0]),
              ...horario[1]
            }
            dataModalidades.horarios.push(dataHorarios);
          });

          if (dataModalidades.dias.includes(dayWeek.toString())) {
            arrayPrecios.push(dataModalidades);
          }

        });

        tarifaData.arrayPrecios = arrayPrecios;
      })




    })

    return tar;
  }
  static async getTarifaById(id) {
    /*const firestore = store.getters.getFirebaseApp.firestore;
    const doc = firestore.doc("RVA_Tarifas", id);
    const data = await firestore.getDoc(doc);
    let dataTarifa = { id: data.ref.id, ...data.data() };
    return dataTarifa;*/
    let tarifaData =  this.$pgsHelper.getById(store.getters["dataLists/getRVATarifas"],"id",id) 
    let dataTarifa = { id: tarifaData.id, ...tarifaData };
    return dataTarifa;
  }
  static async getTarifasParsebyTemp(arrayhorarios, arraytemporadas, arraytiposJuego) {
    let tar = store.getters["dataLists/getRVATarifas"];

    tar.forEach((tarifaData) => {
      tarifaData.data = this.$pgsHelper.getById(arraytemporadas, 'id', tarifaData.Temporada);
      let arrayPrecios = [];
      let arrayDays = Object.entries(tarifaData.Precios);
      arrayDays.forEach((mod) => {
        let modDias = mod[0].split("-");
        let textDias = "";
        modDias.forEach((element) => {
          textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
        });
        let arrayModalidades = Object.entries(mod[1]);

        arrayModalidades.forEach((modalidad) => {
          let dataModalidades = { id: modalidad[0], dias: modDias, horarios: [] };
          dataModalidades.data = this.$pgsHelper.getById(arraytiposJuego, 'id', modalidad[0]);
          let arrayHorarios = Object.entries(modalidad[1]);
          arrayHorarios.forEach((horario) => {
            let dataHorarios = {
              id: horario[0],
              internalId: tarifaData.id + '-' + dataModalidades.id + '-' + horario[0],
              data: this.$pgsHelper.getById(arrayhorarios, 'id', horario[0]),
              ...horario[1]
            }
            dataModalidades.horarios.push(dataHorarios);
          });

          arrayPrecios.push(dataModalidades);

        });

        tarifaData.arrayPrecios = arrayPrecios;
      })

    })

    return tar;
  }
  static async getMixTarifasByDep( departamentos, temporada = null) {
    
    const tarifasList = store.getters["dataLists/getRVATarifas"];
    let tarDepto = _.filter(tarifasList, function (o) {
      if(departamentos){
        if(temporada) {
          return o.Departamento == departamentos && o.Temporada == temporada
        }
        return o.Departamento== departamentos
      }else{
        return o;
      }
      
    });
    
    let tar = tarDepto;

    tar.forEach((tarifaData) => {

      let arrayPrecios = [];
      let arrayDays = Object.entries(tarifaData.Precios);
      arrayDays.forEach((mod) => {
        let modDias = mod[0].split("-");
        let textDias = "";
        modDias.forEach((element) => {
          textDias += " " + this.$pgsHelper.getDayName(element, "Simple");
        });
        let arrayModalidades = Object.entries(mod[1]);
        arrayModalidades.forEach((modalidad) => {
          let dataModalidades = { id: modalidad[0], textDias: textDias, dias: modDias, horarios: [] };
          let arrayHorarios = Object.entries(modalidad[1]);
          arrayHorarios.forEach((horario) => {
            let dataHorarios = {
              id: horario[0],
              ...horario[1]
            }
            dataModalidades.horarios.push(dataHorarios);
          });
          arrayPrecios.push(dataModalidades);
        });


        tarifaData.arrayPrecios = arrayPrecios;

      })
    })

    return tar;
  }
}